import { DOCUMENT } from '@angular/common';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { NotFoundError, Observable, catchError, throwError } from 'rxjs';
import { HostNameServiceService } from './host-name-service.service';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  private baseUrl =
    'https://' +
    this.document.location.hostname +
    ':' +
    this.document.location.port +
    '/admin-services';

  constructor(
    private http: HttpClient,
    private hostNameServiceService: HostNameServiceService,
    @Inject(DOCUMENT) private document: Document,
  ) {
    this.baseUrl = hostNameServiceService.getHostname();
  }

  getEmpMenu(employeeId: any) {
    const headers = { 'Content-type': 'application/json' };
    return this.http.get(`${this.baseUrl}/menus/empMenuMatrix/` + employeeId, {
      headers,
    });
  }

  grantMenuAccess(payload: any) {
    const headers = { 'Content-type': 'application/json' };
    return this.http.post(`${this.baseUrl}/menus/syncAccess`, payload, {
      headers,
    });
  }
}
